import type { Router } from "vue-router";

/**
 * vue-router starts a re-installed router from the location IT last wrote, not from the address
 * bar, so a URL the shell pushed while the element was unmounted would be overwritten with the
 * company titan was left on. Point its history at the address bar before `app.use(router)`.
 */
export function resyncRouterHistory(
  router: Router,
  location: Pick<
    Location,
    "pathname" | "search" | "hash"
  > = globalThis.location,
): void {
  const current = router.currentRoute?.value;
  const history = router.options?.history;
  if (!current || (current.matched?.length ?? 0) > 0 || !history?.replace)
    return;
  const base = history.base;
  const { pathname, search, hash } = location;
  const path =
    base && pathname.toLowerCase().startsWith(base.toLowerCase())
      ? pathname.slice(base.length)
      : pathname;
  const here = (path || "/") + search + hash;
  if (history.location !== here) history.replace(here);
}

export default resyncRouterHistory;
